import React from 'react'
import store from '../store'
import { push } from 'react-router-redux'
import VisibilitySensor from 'react-visibility-sensor'

const onActive = ({ target, title }) => {
    if(title === 'NewGround Entertainment') {
        document.title = 'NewGround Entertainment'
    } else {
        document.title = `${title} - NewGround Entertainment`
    }
    store.dispatch(push(target))
}

const H1 = ({ section, className }) => (
    <VisibilitySensor onChange={(isVisible) => isVisible && onActive(section)}>
        <h1 className={className}>{section.title}</h1>
    </VisibilitySensor>
)

export default H1


// WEBPACK FOOTER //
// ./src/components/H1.js